import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import CommonInput from "../../../components/forms/CommonInput";
import CommonCheckbox from "../../../components/forms/CommonCheckboxSimNao";
import CommonInputDecimal from "../../../components/forms/CommonInputDecimal";
import {
  handleChange,
  handleChangeCheck,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import { AppContext } from "../../../contexts/AppContext";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function CobrancaModal({
  clientes,
  modalProps,
  cobrancaModalHook,
  valuesHook,
  salvaCobranca,
  salvaNovaCobranca,
}) {
  const { cobrancaModal, setCobrancaModal } = cobrancaModalHook;
  const { values, setValues } = valuesHook;
  const [disabled, setDisabled] = React.useState(false);
  const { baseUrl } = React.useContext(AppContext);
  const tiposJuros = useTipos("tipos_juros");
  const tiposMulta = useTipos("tipos_multa");
  const tiposVencimento = useTipos("tipos_vencimento");

  React.useEffect(() => {
    setDisabled(modalProps === "visualizar");
  }, [modalProps]);

  return (
    <CommonModal
      title={
        modalProps === "nova"
          ? "Nova cobrança"
          : modalProps === "editar"
            ? "Editar cobrança"
            : "Visualizar cobrança"
      }
      is_open_modal={cobrancaModal}
      set_is_open_modal={setCobrancaModal}
      buttons={
        modalProps === "nova" ? (
          <button
            key={`nova-cobranca`}
            type="button"
            onClick={salvaNovaCobranca}
            className="btn btn-success"
          >
            Salvar
          </button>
        ) : modalProps === "editar" ? (
          <button
            key={`editar-cobranca`}
            type="button"
            onClick={salvaCobranca}
            className="btn btn-success"
          >
            Salvar
          </button>
        ) : (
          <></>
        )
      }
      size="xl"
    >
      <div className="row">
        <div className="col-lg-10 mb-3">
          <CommonSelect
            label="Cliente"
            id="cliente"
            value={values.cliente}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex];
              const selectedMail = selectedOption
                ? selectedOption?.dataset?.mail
                : null;

              setValues({
                ...values,
                [e.target.name]: e.target.value,
                email: selectedMail,
              });
            }}
            data={clientes.map((cliente) => ({
              text: `${cliente.razao_social} (${
                cliente.cnpj.length === 14
                  ? cliente.cnpj.replace(
                      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
                      "$1.$2.$3/$4-$5"
                    )
                  : cliente.cnpj.replace(
                      /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
                      "$1.$2.$3-$4"
                    )
              })`,
              id: cliente.uid,
              "data-mail": cliente.email,
            }))}
            placeholder="Selecione o cliente"
            disabled={disabled}
          />
        </div>
        <div className="col-lg-2 mb-3 d-flex align-items-end justify-content-end">
          {modalProps === "nova" ? (
            <button
              type="button"
              onClick={() => {
                window.location.href = baseUrl + "cliente/Cliente";
              }}
              className="btn btn-success"
            >
              Cadastrar cliente
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                window.location.href =
                  baseUrl + "cliente/Cliente/editar/" + values.cliente;
              }}
              className="btn btn-success"
            >
              Editar cliente
            </button>
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-8 mb-3">
          <CommonTextArea
            label="Descrição do serviço prestado"
            id="descricao"
            value={values.descricao}
            onChange={(e) => handleChange(e, values, setValues)}
            rows="1"
            maxlength="256"
            disabled={disabled}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInputValor
            label="Valor total"
            id="valor_total"
            value={values.valor_total}
            onChange={(e) => {
              handleChangeNameValue(
                "valor_total",
                e.target.value,
                values,
                setValues
              );
            }}
            disabled={disabled}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonSelect
            label="Tipo de vencimento"
            id="tipo_vencimento"
            value={values.tipo_vencimento}
            onChange={(e) => handleChange(e, values, setValues)}
            data={tiposVencimento.map((vencimento) => ({
              text: vencimento.valor,
              id: vencimento.chave,
            }))}
            placeholder="Selecione o tipo"
            disabled={disabled}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInput
            label="Dia do vencimento"
            id="dia_vencimento"
            value={values.dia_vencimento}
            onChange={(e) => handleChangeNumeral(e, values, setValues, 1, 31)}
            disabled={disabled}
          />
        </div>
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckbox
            label="Multa e juros"
            id="multa_juros"
            value={values.multa_juros}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
            disabled={disabled}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonSelect
            label="Tipo de multa"
            id="tipo_multa"
            value={values.tipo_multa}
            onChange={(e) => handleChange(e, values, setValues)}
            data={tiposMulta.map((multa) => ({
              text: multa.valor,
              id: multa.chave,
            }))}
            placeholder="Selecione o tipo"
            disabled={disabled || !values.multa_juros}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInputDecimal
            label="Multa"
            id="multa"
            value={values.multa}
            onChange={(value) => {
              handleChangeNameValue(
                "multa",
                value.floatValue,
                values,
                setValues
              );
            }}
            disabled={disabled || !values.multa_juros}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-2 mb-3">
          <CommonSelect
            label="Tipo de juros"
            id="tipo_juros"
            value={values.tipo_juros}
            onChange={(e) => handleChange(e, values, setValues)}
            data={tiposJuros.map((juros) => ({
              text: juros.valor,
              id: juros.chave,
            }))}
            placeholder="Selecione o tipo"
            disabled={disabled || !values.multa_juros}
          />
        </div>
        <div className="col-lg-2 mb-3">
          <CommonInputDecimal
            label="Juros"
            id="juros"
            value={values.juros}
            onChange={(value) => {
              handleChangeNameValue(
                "juros",
                value.floatValue,
                values,
                setValues
              );
            }}
            disabled={disabled || !values.multa_juros}
          />
        </div>
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckbox
            label="Emitir NFS-e"
            id="emitir_nfse"
            value={values.emitir_nfse}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
            disabled={disabled}
          />
        </div>
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckbox
            label="Emitir boleto"
            id="emitir_boleto"
            value={values.emitir_boleto}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
            disabled={disabled}
          />
        </div>
        <div className="col d-flex justify-content-center mb-3">
          <CommonCheckbox
            label="Enviar E-mail"
            id="enviar_email"
            value={values.enviar_email}
            onChange={(e) => handleChangeCheck(e, values, setValues)}
            disabled={disabled}
          />
        </div>
        <div className="col-lg-4 mb-3">
          {values.enviar_email ? (
            <>
              <CommonInput
                label="E-mail"
                id="email"
                value={values.email}
                onChange={(e) => handleChange(e, values, setValues)}
                type="email"
                disabled={disabled}
              />
              <small>
                Se precisar adicionar mais e-mails, por favor, insira-os
                separados por vírgula(,)
              </small>
            </>
          ) : null}
        </div>
      </div>
    </CommonModal>
  );
}

CobrancaModal.propTypes = {
  clientes: PropTypes.arrayOf(
    PropTypes.shape({
      razao_social: PropTypes.string.isRequired,
      cnpj: PropTypes.string.isRequired,
      uid: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    })
  ).isRequired,
  modalProps: PropTypes.oneOf(["nova", "editar", "visualizar"]).isRequired,
  cobrancaModalHook: PropTypes.shape({
    cobrancaModal: PropTypes.bool.isRequired,
    setCobrancaModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaCobranca: PropTypes.func.isRequired,
  salvaNovaCobranca: PropTypes.func.isRequired,
};

export default CobrancaModal;
